export default class DocumentNotFoundError extends Error {
  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, DocumentNotFoundError.prototype);
  }
}
